<sz-app-shell>
  <sz-top-bar />

  <div class="drill-edit">
    @if (drill(); as d) {
      <sz-page-title [title]="'drills.edit.title' | translate" [accent]="d.name" size="xl" [showBack]="true" />
      <lib-drill-form [initialValue]="d" (formSubmit)="onSubmit($event)" />
    } @else {
      <div class="drill-edit__skeleton">
        <sz-skeleton shape="text" width="55%" height="28px" />
        <sz-skeleton shape="block" height="56px" />
        <sz-skeleton shape="block" height="56px" />
        <sz-skeleton shape="block" height="44px" />
        <sz-skeleton shape="block" height="96px" />
        <sz-skeleton shape="block" height="44px" />
      </div>
    }
  </div>

  @if (drill()) {
    <sz-cta-bar variant="floating">
      <sz-button variant="primary" [fullWidth]="true" [disabled]="!canSubmit()" (click)="triggerSubmit()">
        <sz-icon name="check" [size]="16" />
        {{ 'drills.edit.cta' | translate }}
      </sz-button>
    </sz-cta-bar>
  }
</sz-app-shell>
